var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_report",
    "data-name": "icona report",
    transform: "translate(-51.458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3123",
    "data-name": "Raggruppa 3123",
    transform: "translate(51.458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3122",
    "data-name": "Raggruppa 3122",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_889",
    "data-name": "Tracciato 889",
    d: "M65.754,2.914H63.465V2.055c0-.245-.268-.445-.6-.445h-.839L60.929.221A.675.675,0,0,0,60.408,0h-1.9a.666.666,0,0,0-.521.221L56.9,1.607h-.836c-.332,0-.6.2-.6.445v.859H53.165c-.943,0-1.707.564-1.707,1.26V14.74c0,.7.764,1.26,1.707,1.26H65.751c.943,0,1.707-.564,1.707-1.26V4.174C67.462,3.478,66.7,2.914,65.754,2.914ZM58.858.888h1.2l.568.719H58.29ZM56.665,2.5h5.6V3.963h-5.6Zm9.6,12.242h0c0,.206-.225.372-.5.372H53.169c-.279,0-.5-.166-.5-.372V4.174c0-.206.225-.372.5-.372h2.293v.6c0,.245.268.445.6.445h6.8c.332,0,.6-.2.6-.445V3.8h2.289c.279,0,.5.166.5.372V14.74Z",
    transform: "translate(-51.458)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3125",
    "data-name": "Raggruppa 3125",
    transform: "translate(60.565 5.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3124",
    "data-name": "Raggruppa 3124",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_890",
    "data-name": "Tracciato 890",
    d: "M220.389,141.511h-3.479c-.332,0-.6.2-.6.445v2.92c0,.245.268.445.6.445h3.479c.332,0,.6-.2.6-.445v-2.922C220.993,141.711,220.725,141.511,220.389,141.511Zm-.6,2.925h-2.275V142.4h2.275Z",
    transform: "translate(-216.307 -141.511)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3127",
    "data-name": "Raggruppa 3127",
    transform: "translate(53.672 6.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3126",
    "data-name": "Raggruppa 3126",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_891",
    "data-name": "Tracciato 891",
    d: "M96.829,155.475H92.144c-.332,0-.6.2-.6.445s.268.445.6.445h4.686c.332,0,.6-.2.6-.445S97.165,155.475,96.829,155.475Z",
    transform: "translate(-91.54 -155.475)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3129",
    "data-name": "Raggruppa 3129",
    transform: "translate(53.672 8.69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3128",
    "data-name": "Raggruppa 3128",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_892",
    "data-name": "Tracciato 892",
    d: "M96.829,213.2H92.144c-.332,0-.6.2-.6.445s.268.445.6.445h4.686c.332,0,.6-.2.6-.445S97.165,213.2,96.829,213.2Z",
    transform: "translate(-91.54 -213.204)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3131",
    "data-name": "Raggruppa 3131",
    transform: "translate(53.672 11.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3130",
    "data-name": "Raggruppa 3130",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_893",
    "data-name": "Tracciato 893",
    d: "M102.515,270.933H92.144c-.332,0-.6.2-.6.445s.268.445.6.445h10.379c.332,0,.6-.2.6-.445A.555.555,0,0,0,102.515,270.933Z",
    transform: "translate(-91.54 -270.933)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3133",
    "data-name": "Raggruppa 3133",
    transform: "translate(53.672 13.397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3132",
    "data-name": "Raggruppa 3132",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_894",
    "data-name": "Tracciato 894",
    d: "M102.515,328.663H92.144c-.332,0-.6.2-.6.445s.268.445.6.445h10.379c.332,0,.6-.2.6-.445S102.851,328.663,102.515,328.663Z",
    transform: "translate(-91.54 -328.663)",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.80e59baf9ec9c16a34049fa9fdf6f77f.svg";
export { ForwardRef as ReactComponent };